import { render, staticRenderFns } from "./TextareaComponent.vue?vue&type=template&id=0fd9a9ad"
import script from "./TextareaComponent.vue?vue&type=script&lang=js"
export * from "./TextareaComponent.vue?vue&type=script&lang=js"
import style0 from "./TextareaComponent.vue?vue&type=style&index=0&id=0fd9a9ad&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd9a9ad')) {
      api.createRecord('0fd9a9ad', component.options)
    } else {
      api.reload('0fd9a9ad', component.options)
    }
    module.hot.accept("./TextareaComponent.vue?vue&type=template&id=0fd9a9ad", function () {
      api.rerender('0fd9a9ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/TextareaComponent.vue"
export default component.exports